/* -----------------------------------------------
   TD 2026-10-13 SECOND15 — "Zweite Maske dazu" / "Zweiten Kragen dazu" (snippets/td-addon-switch.liquid, mode 'same').
   Felix 13.10.2026: "Add the upsell options to the Gewichtsmaske and Gewichtskragen to get 15% when ordering a 2nd one."
   Loaded only by a shown "second unit" box (module: runs once per page). assets/custom.js (initTdUpsellAddon) still does
   the switch, the colour dots / chips, the thumbnail and the add-to-cart request; this file only does two things for the
   boxes with data-td-addon-same:
   - Price: the struck price of the second unit and "(+ what it adds)" = its price − percent of the CHEAPER of the two
     units (the page's selected variant and the second unit). The discount app (SMART Functions Creator, "2. Stück −15%":
     buy 1 → get 1 at 15% inside the group, per pair, "Highest priced first") gives the 15% to the most expensive units,
     so adding a pair raises the cart discount by at least 15% of the dearer unit: the shown price is a conservative lower
     bound, also with units of the group already in the cart (Codex R1, 13.10.2026). Same rounding and money format as
     snippets/td-addon-switch.liquid / assets/custom.js. Display only.
   - The second unit follows the page's selection (colour / weight / size) until the buyer picks a value in the box
     (a trusted change event inside the box); a selection that cannot be ordered is not copied.
   The box's price element carries data-td-second-price (not data-td-upsell-price), so custom.js never paints its own
   add-on formula into it.
   ----------------------------------------------- */
(() => {
  if (window.tdSecondUnitReady) return;
  window.tdSecondUnitReady = true;

  /* shop money format '{{amount_with_comma_separator}}€' (no space before €), as assets/custom.js */
  const formatMoney = (cents) => `${(cents / 100).toFixed(2).replace('.', ',')}€`;
  const escapeHtml = (text) => String(text || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  /* rounded like Shopify rounds a percentage discount (Liquid: base × percent + 50, divided by 100) */
  const offOf = (cents, percent) => Math.floor((cents * percent + 50) / 100);

  const boxes = () => Array.from(document.querySelectorAll('[data-td-upsell-addon][data-td-addon-same]'));
  const percentOf = (box) => {
    const n = parseInt(box.dataset.tdSecondPercent || '0', 10);
    return n > 0 && n < 100 ? n : 0;
  };
  const variantsOf = (box) => {
    const script = box.nextElementSibling && box.nextElementSibling.matches('script[data-td-upsell-variants-json]') ? box.nextElementSibling : null;
    try {
      return script ? JSON.parse(script.textContent || '[]') : [];
    } catch (error) {
      return [];
    }
  };
  const formOf = (box) => document.getElementById(box.dataset.tdUpsellFormId || '');
  const mainIdOf = (box) => {
    const form = formOf(box);
    const input = form ? form.querySelector('[name="id"]') : null;
    return input ? String(input.value || '') : '';
  };
  const secondOf = (box, variants) => {
    const input = box.querySelector('[data-td-upsell-variant-id]');
    return input ? variants.find((v) => String(v.id) === String(input.value)) || null : null;
  };

  /* price of the main unit per box (cents), set from the theme's variant:change; until then the form's variant */
  const mainPrice = new WeakMap();

  const paint = (box) => {
    const priceEl = box.querySelector('[data-td-second-price]');
    const variants = variantsOf(box);
    const second = secondOf(box, variants);
    if (!priceEl || !second) return;
    let main = mainPrice.get(box);
    if (typeof main !== 'number') {
      const own = variants.find((v) => String(v.id) === mainIdOf(box));
      main = own ? own.price : second.price;
    }
    const percent = percentOf(box);
    const regular = priceEl.dataset.labelRegular || '';
    const sale = priceEl.dataset.labelSale || '';
    const struck = (html) => `<s class="td-upsell-addon__compare-price" data-td-upsell-compare-price>${regular ? `<span class="sr-only">${escapeHtml(regular)} </span>` : ''}${html}</s> `;
    const plus = (cents) => `(+ ${sale ? `<span class="sr-only">${escapeHtml(sale)} </span>` : ''}${formatMoney(cents)})`;
    if (percent) {
      const shown = second.price - offOf(Math.min(main, second.price), percent);
      priceEl.innerHTML = struck(formatMoney(second.price)) + plus(shown);
    } else if (second.compare_at_price && second.compare_at_price > second.price) {
      priceEl.innerHTML = struck(formatMoney(second.compare_at_price)) + plus(second.price);
    } else {
      priceEl.innerHTML = `(+ ${formatMoney(second.price)})`;
    }
  };

  /* the second unit takes the main unit's option values (only an orderable combination); assets/custom.js resolves the
     variant on the change event (hidden variant id, thumbnail, values that fit) */
  let syncing = false;
  const follow = (box, variant) => {
    if (!variant || !Array.isArray(variant.options) || box.dataset.tdSecondTouched === 'true') return;
    const variants = variantsOf(box);
    const target = variants.find((v) => String(v.id) === String(variant.id));
    if (!target || target.available === false) return;
    const groups = Array.from(box.querySelectorAll('[data-td-choice][data-option-index]'));
    let changed = null;
    groups.forEach((group) => {
      const index = parseInt(group.dataset.optionIndex, 10);
      const value = target.options[index];
      const radio = Array.from(group.querySelectorAll('input[type="radio"]')).find((r) => r.value === value);
      if (radio && !radio.checked) {
        radio.checked = true;
        changed = changed || radio;
      }
    });
    if (!changed) return;
    syncing = true;
    try {
      changed.dispatchEvent(new Event('change', { bubbles: true }));
    } finally {
      syncing = false;
    }
  };

  const setup = (box) => {
    if (box.dataset.tdSecondReady === 'true') return;
    box.dataset.tdSecondReady = 'true';
    /* a value picked by the buyer: the box keeps it from now on (custom.js has resolved the variant by now: its listener
       sits on the option group, below this one) */
    box.addEventListener('change', (event) => {
      if (event.target && event.target.matches && event.target.matches('[data-td-choice] input[type="radio"]')) {
        if (event.isTrusted && !syncing) box.dataset.tdSecondTouched = 'true';
        paint(box);
      }
    });
    paint(box);
  };

  const setupAll = () => boxes().forEach(setup);
  setupAll();

  /* the page's selection changed (theme.js VariantPicker: variant:change on the product form, bubbles) */
  document.addEventListener('variant:change', (event) => {
    const form = event.target;
    const formId = form && typeof form.getAttribute === 'function' ? form.getAttribute('id') : '';
    if (!formId) return;
    const variant = event.detail && event.detail.variant;
    boxes().filter((box) => box.dataset.tdUpsellFormId === formId).forEach((box) => {
      setup(box);
      if (variant && typeof variant.price === 'number') mainPrice.set(box, variant.price);
      follow(box, variant);
      paint(box);
    });
  });

  /* a product change replaces the whole product info: set up the new box after assets/custom.js has (both wait a tick) */
  document.addEventListener('product:rerender', () => window.setTimeout(setupAll, 0), true);
  /* back / forward cache: the browser may restore other choices */
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) boxes().forEach(paint);
  });
})();
